import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Heading = styled.div`
  background-color: ${COLORS.WHITE};
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 4px 0px 0;
  color: inherit;
  margin-bottom: 0;
  padding: 20px 15px 10px;
  position: relative;
  font-size: 14px;
  font-weight: bold;
`;

const Container = styled.div`
  min-height: calc(100vh - 180px);
  padding: 0 15px;
`;
const Detail = styled.div`
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-top: 1px solid #e7eaec;
  h2 {
    margin-top: 5px;
    font-size: 24px;
    font-weight: 100;
  }
`;
const Row1 = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 30px;
  @media (min-width: 960px) {
    flex-direction: row;
  }
  > div {
    button {
      font-size: 14px;
      min-width: 120px;
      border-radius: 3px;
      padding: 14px 5px;
      line-height: 1.5;
      text-transform: inherit;
      color: ${COLORS.WHITE};
      background-color: ${COLORS.BLACK};
      margin-bottom: '15px';
      :hover {
        background-color: ${COLORS.BLACK};
      }
    }
    &:first-child {
      flex: 0.66;
      display: flex;
      flex-direction: column;
      > div {
        margin-bottom: 15px;
      }
    }
    &:last-child {
      flex: 0.34;
      label {
        margin-bottom: 5px;
        font-weight: 700;
        display: inline-block;
      }
      p {
        margin-top: 0;
      }
    }
    @media (min-width: 960px) {
      padding: 0 15px;
    }
  }
`;
const Row2 = styled.div`
  display: grid;
  padding: 0 15px;
  grid-gap: 30px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Img = styled.img`
  width: 100%;
`;

const TextHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
  p {
    color: #1594db;
    font-size: 16px;
    line-height: 32px;
    margin: 0;
  }
`;

const TextSection = styled.div`
  padding: 14px 24px;
  p {
    font-size: 14px;
  }
`;

const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #e6e6e6;
  p {
    line-height: 32px;
    font-size: 16px;
    margin: 0;
    padding-bottom: 10px;
    padding-right: 60px;
    position: relative;

    ::after {
      content: '';
      display: inline-block;
      width: 100%;
      height: 5px;
      background: #ffd363;
      position: absolute;
      bottom: -3px;
      right: 0;
    }
  }
`;
export {
  Container,
  Heading,
  Detail,
  Row1,
  Row2,
  Img,
  TextHeader,
  TextSection,
  TitleSection,
};
